/* WAM.js */

import axios from 'axios';
import { buildDsParam } from './dsParam';

const PZ_BASE_URL_LOGIN_SIGNUP = process.env.REACT_APP_PZ_BASE_URL_LOGIN_SIGNUP;
const PZ_BASE_URL_OTHER = process.env.REACT_APP_PZ_BASE_URL_OTHER;
const BASE_APP = process.env.REACT_APP_NAME;
const BASE_CLIENT = process.env.REACT_APP_CLIENT;
const BASE_VERSION = process.env.REACT_APP_VERSION;
const BASE_BUILD = process.env.REACT_APP_BUILD;
const BASE_DS = buildDsParam(BASE_APP, BASE_CLIENT);
const WAM_URL_LOGIN_SIGNUP = `${PZ_BASE_URL_LOGIN_SIGNUP}{method}.php?client=${BASE_CLIENT}&app=${BASE_APP}&version=${BASE_VERSION}&build=${BASE_BUILD}&ds=${encodeURIComponent(BASE_DS)}`;
const WAM_URL_OTHER = `${PZ_BASE_URL_OTHER}{method}.php?client=${BASE_CLIENT}&app=${BASE_APP}&version=${BASE_VERSION}&build=${BASE_BUILD}&ds=${encodeURIComponent(BASE_DS)}`;

const WAM = {

  login: async function ({ un, pwd }) {
    const method = 'WAMLogin';
    const url = WAM_URL_LOGIN_SIGNUP.replace('{method}', method);

    const formData = new FormData();
    formData.append('method', 'WAMLogin');
    formData.append(un.match(/@/) ? 'email' : 'username', un);
    formData.append('password', pwd);

    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: url,
        data: formData
      })
        .then((response) => {
          return resolve(this.convertToJson(response.data));
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

  logout: async function ({ un, al }) {
    const method = 'WAMLogout';
    const url = WAM_URL_OTHER.replace('{method}', method);

    const formData = new FormData();
    formData.append('method', 'WAMLogout');
    formData.append('username', un);
    formData.append('authorized_login_id', al);

    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: url,
        data: formData
      })
        .then((response) => {
          return resolve(response);
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

  forgot: async function ({ un }) {
    const method = 'WAMForgotPassword';
    const url = WAM_URL_OTHER.replace('{method}', method);

    const formData = new FormData();
    formData.append('method', 'WAMForgotPassword');
    formData.append(un.match(/@/) ? 'email' : 'username', un);

    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: url,
        data: formData
      })
        .then((response) => {
          return resolve(this.convertToJson(response.data));
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

  changeUserPassword: async function ({ un, al, oldPwd, newPwd }) {
    const method = 'WAMChangeUserPassword';
    const url = WAM_URL_OTHER.replace('{method}', method);
    
    const formData = new FormData();
    formData.append('username', un);
    formData.append('authorized_login_id', al);
    formData.append('old_password', oldPwd);
    formData.append('new_password', newPwd);

    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: url,
        data: formData
      })
        .then((response) => {
          return resolve(this.convertToJson(response.data));
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

  signup: async function ({ un, email, pwd }) {
    const method = 'WAMSignup';
    const url = WAM_URL_LOGIN_SIGNUP.replace('{method}', method);

    const formData = new FormData();
    formData.append('method', method);
    formData.append('username', un);
    formData.append('password', pwd);
    formData.append('email', email);

    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: url,
        data: formData
      })
        .then((response) => {
          return resolve(this.convertToJson(response.data));
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

  getUserProfile: async function ({ un, al, version }) {
    const method = 'WAMGetUserProfile';
    const url = WAM_URL_OTHER.replace('{method}', method);

    const formData = new FormData();
    formData.append('username', un);
    formData.append('authorized_login_id', al);
    if (version !== undefined) { formData.append('version', version); }

    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: url,
        data: formData
      })
        .then((response) => {
          return resolve(this.convertToJson(response.data));
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

  setUserProfile: async function ({ un, al, name, desc, url, email, photo }) {
    const method = 'WAMSetUserProfile';
    const wamUrl = WAM_URL_OTHER.replace('{method}', method);

    const formData = new FormData();
    formData.append('method', method);
    formData.append('authorized_login_id', al);
    formData.append('username', un);

    let countObj = 0;

    if (name) {
      formData.append(`obj${++countObj}`, `2;${name || ''};`);
      formData.append('fullName', name || '');
    }
    if (desc) {
      formData.append(`obj${++countObj}`, `4;${desc || ''};`);
      formData.append('biography', desc || '');
    }
    if (url) {
      formData.append(`obj${++countObj}`, `6;${url || ''};`);
      formData.append('site', url || '');
    }
    if (email) {
      formData.append(`obj${++countObj}`, `7;${email}`);
      formData.append('email', email);
    }
    if (photo) {
      formData.append(`obj${++countObj}`, `5;${photo.name};`);
      formData.append('Filedata1', photo);
      formData.append('Filename', photo.name);
    }

    formData.append('obj_count', countObj.toString());

    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: wamUrl,
        data: formData
      })
        .then((response) => {
          return resolve(this.convertToJson(response.data));
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

  changeUserEmail: async function ({ al, un, newEmail }) {
    const method = 'WAMChangeUserEmail';
    const url = WAM_URL_OTHER.replace('{method}', method);

    const formData = new FormData();
    formData.append('method', method);
    formData.append('authorized_login_id', al);
    formData.append('username', un);
    formData.append('new_email', newEmail);

    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: url,
        data: formData
      })
        .then((response) => {
          return resolve(this.convertToJson(response.data));
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

  validateSession: async function ({ un, al }) {
    const method = 'WAMValidateSession';
    const url = WAM_URL_OTHER.replace('{method}', method);

    const formData = new FormData();
    formData.append('method', method);
    formData.append('version', 'v2');
    formData.append('username', un);
    formData.append('authorized_login_id', al);

    return new Promise((resolve, reject) => {
      axios({ method: 'POST', url: url, data: formData})
        .then((response) => {
          return resolve(this.convertToJson(response.data));
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

  createAlbum: async function ({ un, al, albumName, albumDesc, albumDate, albumYear, albumTheme, albumPerm, albumNPhotos, albumCover, albumHosts, albumSource, albumStyle, albumCommunityId, albumCommunityName, albumCommunityUrl, albumCommunitySuggestUrl, citId, citName, citProvince, couName, hasMovie, movieJson, rmxElementIds, rmxElementTypes, rmxFileNames, rmxId, rmxMediaOnly, rmxPhotoSortOrderIds }) {
    const method = 'WAMCreateAlbum';
    const url = WAM_URL_OTHER.replace('{method}', method);

    const formData = new FormData();
    if (al !== undefined) { formData.append('authorized_login_id', al); }
    if (un !== undefined) { formData.append('username', un); }
    if (albumName !== undefined) { formData.append('album_name', albumName); }
    if (albumDesc !== undefined) { formData.append('album_description', albumDesc); }
    if (albumDate !== undefined) { formData.append('album_date', albumDate); }
    if (albumYear !== undefined) { formData.append('album_year', albumYear); }
    if (albumTheme !== undefined) { formData.append('album_theme', albumTheme); }
    if (albumPerm !== undefined) { formData.append('album_permission', albumPerm); }
    if (albumNPhotos !== undefined) { formData.append('album_number_photos', albumNPhotos); }
    if (albumCover !== undefined) { formData.append('album_cover', albumCover); }
    if (albumHosts !== undefined) { formData.append('album_hosts', albumHosts); }
    if (albumSource !== undefined) { formData.append('album_source', albumSource); }
    if (albumStyle !== undefined) { formData.append('album_style', albumStyle); }
    if (albumCommunityId !== undefined) { formData.append('album_community_id', albumCommunityId); }
    if (albumCommunityName !== undefined) { formData.append('album_community_name', albumCommunityName); }
    if (albumCommunityUrl !== undefined) { formData.append('album_community_url', albumCommunityUrl); }
    if (albumCommunitySuggestUrl !== undefined) { formData.append('album_community_suggest_url', albumCommunitySuggestUrl); }
    if (citId !== undefined) { formData.append('cit_id', citId); }
    if (citName !== undefined) { formData.append('cit_name', citName); }
    if (citProvince !== undefined) { formData.append('cit_province', citProvince); }
    if (couName !== undefined) { formData.append('cou_name', couName); }
    if (hasMovie !== undefined) { formData.append('has_movie', hasMovie); }
    if (movieJson !== undefined) { formData.append('movie_json', JSON.stringify(movieJson)); }

    if (rmxElementIds !== undefined) { formData.append('rmx_element_ids', JSON.stringify(rmxElementIds)); }
    if (rmxElementTypes !== undefined) { formData.append('rmx_element_types', JSON.stringify(rmxElementTypes)); }
    if (rmxFileNames !== undefined) { formData.append('rmx_file_names', JSON.stringify(rmxFileNames)); }
    if (rmxPhotoSortOrderIds !== undefined) { formData.append('rmx_photo_sort_order_ids', JSON.stringify(rmxPhotoSortOrderIds)); }
    if (rmxId !== undefined) { formData.append('rmx_id', rmxId); }
    if (rmxMediaOnly !== undefined) { formData.append('rmx_media_only', rmxMediaOnly); }

    return new Promise((resolve, reject) => {
      axios({ method: 'POST', url: url, data: formData})
        .then((response) => {
          return resolve(this.convertToJson(response.data));
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

  createPhoto: async function ({ un, al, albumId, databaseId, photoFileName, photoSize, photoWidth, photoHeight, photoThumbWidth, photoThumbHeight, photoSortOrderId, photoTitle, photoDescription, photoTag, photoHidden, photoDelete, requesterId, pzaPhotoId, pzaChecksum, pzaTime, pzaOrigTime, pzaOrigSize, pzaOrigChecksum, pzaSize }) {
    const method = 'WAMCreatePhoto';
    const url = WAM_URL_OTHER.replace('{method}', method);

    const formData = new FormData();
    if (al !== undefined) { formData.append('authorized_login_id', al); }
    if (un !== undefined) { formData.append('username', un); }
    if (albumId !== undefined) { formData.append('album_id', albumId); }
    if (databaseId !== undefined) { formData.append('database_id', databaseId); }
    if (photoFileName !== undefined) { formData.append('photo_file_name', photoFileName); }
    if (photoSize !== undefined) { formData.append('photo_size', photoSize); }
    if (photoWidth !== undefined) { formData.append('photo_width', photoWidth); }
    if (photoHeight !== undefined) { formData.append('photo_height', photoHeight); }
    if (photoThumbWidth !== undefined) { formData.append('photo_thumb_width', photoThumbWidth); }
    if (photoThumbHeight !== undefined) { formData.append('photo_thumb_height', photoThumbHeight); }
    if (photoSortOrderId !== undefined) { formData.append('photo_sort_order_id', photoSortOrderId); }
    if (photoTitle !== undefined) { formData.append('photo_title', photoTitle); }
    if (photoDescription !== undefined) { formData.append('photo_description', photoDescription); }
    if (photoTag !== undefined) { formData.append('photo_tag', photoTag); }
    if (photoHidden !== undefined) { formData.append('photo_hidden', photoHidden); }
    if (photoDelete !== undefined) { formData.append('photo_delete', photoDelete); }
    if (requesterId !== undefined) { formData.append('requester_id', requesterId); }
    if (pzaPhotoId !== undefined) { formData.append('PZA_photo_id', pzaPhotoId); }
    if (pzaChecksum !== undefined) { formData.append('PZA_checksum', pzaChecksum); }
    if (pzaTime !== undefined) { formData.append('PZA_time', pzaTime); }
    if (pzaOrigTime !== undefined) { formData.append('PZA_orig_time', pzaOrigTime); }
    if (pzaOrigSize !== undefined) { formData.append('PZA_orig_size', pzaOrigSize); }
    if (pzaOrigChecksum !== undefined) { formData.append('PZA_orig_checksum', pzaOrigChecksum); }
    if (pzaSize !== undefined) { formData.append('PZA_size', pzaSize); }

    return new Promise((resolve, reject) => {
      axios({ method: 'POST', url: url, data: formData})
        .then((response) => {
          return resolve(this.convertToJson(response.data));
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

  uploadPhoto: async function ({ un, al, albumId, photoId, client, photoScope, autoResize, fileData, clientTimeUpload }) {
    const method = 'WAMUploadPhoto';
    const url = WAM_URL_OTHER.replace('{method}', method);

    const formData = new FormData();
    if (al !== undefined) { formData.append('authorized_login_id', al); }
    if (un !== undefined) { formData.append('username', un); }
    if (albumId !== undefined) { formData.append('album_id', albumId); }
    if (photoId !== undefined) { formData.append('photo_id', photoId); }
    if (client !== undefined) { formData.append('client', client); }
    if (photoScope !== undefined) { formData.append('photo_scope', photoScope); }
    if (autoResize !== undefined) { formData.append('auto_resize', autoResize); }
    if (fileData !== undefined) { formData.append('Filedata', fileData); }
    if (clientTimeUpload !== undefined) { formData.append('client_time_upload', clientTimeUpload); }

    return new Promise((resolve, reject) => {
      axios({ method: 'POST', url: url, data: formData})
        .then((response) => {
          return resolve(this.convertToJson(response.data));
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

  uploadVideo: async function ({ un, al, albumId, photoId, client, fileData }) {
    const method = 'WAMUploadVideo';
    const url = WAM_URL_OTHER.replace('{method}', method);

    const formData = new FormData();
    if (al !== undefined) { formData.append('authorized_login_id', al); }
    if (un !== undefined) { formData.append('username', un); }
    if (albumId !== undefined) { formData.append('album_id', albumId); }
    if (photoId !== undefined) { formData.append('photo_id', photoId); }
    if (client !== undefined) { formData.append('client', client); }
    if (fileData !== undefined) { formData.append('Filedata', fileData); }

    return new Promise((resolve, reject) => {
      axios({ method: 'POST', url: url, data: formData})
        .then((response) => {
          return resolve(this.convertToJson(response.data));
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

  uploadStatus: async function ({ un, al, albumId, movieId }) {
    const method = 'WAMUploadStatus';
    const url = WAM_URL_OTHER.replace('{method}', method);

    const formData = new FormData();
    if (un !== undefined) { formData.append('authorized_login_id', al); }
    if (al !== undefined) { formData.append('username', un); }
    if (albumId !== undefined) { formData.append('album_id', albumId); }
    if (movieId !== undefined) { formData.append('movie_id', movieId); }

    return new Promise((resolve, reject) => {
      axios({ method: 'POST', url: url, data: formData})
        .then((response) => {
          return resolve(this.convertToJson(response.data));
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

  publishAlbum: async function ({ un, al, albumId, albumsSortType, userTimestamp, albumTimestamp, albumProtected, albumProtectedPass, albumProtectedPassGlobal, doNotRepublish, doNotPublishAlbum, movieId }) {
    const method = 'WAMPublishAlbum';
    const url = WAM_URL_OTHER.replace('{method}', method);

    const formData = new FormData();
    if (al !== undefined) { formData.append('authorized_login_id', al); }
    if (un !== undefined) { formData.append('username', un); }
    if (albumId !== undefined) { formData.append('album_id', albumId); }
    if (albumsSortType !== undefined) { formData.append('albums_sort_type', albumsSortType); }
    if (userTimestamp !== undefined) { formData.append('user_timestamp', userTimestamp); }
    if (albumTimestamp !== undefined) { formData.append('album_timestamp', albumTimestamp); }
    if (albumProtected !== undefined) { formData.append('album_protected', albumProtected); }
    if (albumProtectedPass !== undefined) { formData.append('album_protected_pass', albumProtectedPass); }
    if (albumProtectedPassGlobal !== undefined) { formData.append('album_protected_pass_global', albumProtectedPassGlobal); }
    if (doNotRepublish !== undefined) { formData.append('do_not_republish', doNotRepublish); }
    if (doNotPublishAlbum !== undefined) { formData.append('do_not_publish_album', doNotPublishAlbum); }
    if (movieId !== undefined) { formData.append('movie_id', movieId); }

    return new Promise((resolve, reject) => {
      axios({ method: 'POST', url: url, data: formData})
        .then((response) => {
          return resolve(this.convertToJson(response.data));
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

  movieStatus: async function ({ un, al, movieId, albumId }) {
    const method = 'WAMMovieStatus';
    const url = WAM_URL_OTHER.replace('{method}', method);

    const formData = new FormData();
    if (un !== undefined) { formData.append('authorized_login_id', al); }
    if (al !== undefined) { formData.append('username', un); }
    if (movieId !== undefined) { formData.append('movie_id', movieId); }
    if (albumId !== undefined) { formData.append('album_id', albumId); }

    return new Promise((resolve, reject) => {
      axios({ method: 'POST', url: url, data: formData})
        .then((response) => {
          return resolve(this.convertToJson(response.data));
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

  listToJson: function (list) {
    let pair;
    const json = {};
    const array = list.split('|');
    for (let i = 0; i < array.length; i++) {
      pair = array[i].split(';');
      json[pair[0].replace(/:/g, '')] = pair[1];
    }
    return json;
  },

  convertToJson: function (value) {
    var hash;
    var myJson = {};
    var hashes = value.split("&");
    for (var i = 0; i < hashes.length; i++) {
      hash = hashes[i].split("=");
      myJson[hash[0]] = decodeURIComponent(hash[1]);
    }
    return myJson;
  }
  
};

export default WAM;
